import React from 'react';
import './App.css';
import './index.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Experience from './pages/Experience';
import Writing from './pages/Writing';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

function App() {
  return (
    <div className="app">
      <Router>
        <Navbar />
        <main>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/experience" component={Experience} />
            <Route path="/writing" component={Writing} />
          </Switch>
        </main>
      </Router>
    </div>
  );
}

export default App;
